export default __webpack_public_path__ + "static/media/greek-temple2.81bf3954.png";